import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';

const rootElement = document.getElementById('root');

if (!rootElement) {
  document.body.innerHTML = '<div style="color:red; padding: 20px;">CRITICAL ERROR: Root element not found.</div>';
  throw new Error("Could not find root element to mount to");
}

try {
  const root = ReactDOM.createRoot(rootElement);
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
} catch (error) {
  console.error("Application Crash:", error);
  rootElement.innerHTML = `
    <div style="color: #ef4444; background: #0f172a; padding: 40px; font-family: monospace; height: 100vh;">
      <h1 style="font-size: 24px; margin-bottom: 20px;">System Failure (App Crash)</h1>
      <p>The application failed to start.</p>
      <pre style="background: #1e293b; padding: 20px; border-radius: 8px; overflow: auto;">${error instanceof Error ? error.message : String(error)}</pre>
      <p style="margin-top: 20px; color: #94a3b8;">Please check the browser console (F12) for more details.</p>
    </div>
  `;
}